import { Button } from "@mui/material";

const M_FILES = "M-Files";

export default function MFilesButton({ hyperlink }) {
  if (!hyperlink) return null;
  return (
    <Button
      href={hyperlink}
      title={M_FILES}
      sx={{
        padding: "4px 16px",
      }}
      variant='outlined'
      target='_blank'
    >
      {M_FILES}
    </Button>
  );
}